/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCallOut } from '@elastic/eui'

import type { AnyUserProject } from '@modules/project-user-api/types'
import { isProjectSuspended } from '@modules/project-lib/suspended'
import { FormattedMessage } from '@modules/i18n'

// eslint-disable-next-line import/no-restricted-paths
import CreditCardModalButton from '@/components/Billing/CreditCard/CreditCardModalButton'

export type Props = {
  project: AnyUserProject
}

const SuspendedProjectCallout: React.FunctionComponent<Props> = ({ project }) => {
  if (isProjectSuspended(project)) {
    return (
      <EuiCallOut
        title={
          <FormattedMessage
            id='project.suspendedCallout.title'
            defaultMessage='Project suspended'
          />
        }
        iconType='warning'
        color='warning'
        data-test-id='suspended-project-callout'
      >
        <p>
          <FormattedMessage
            id='project.suspendedCallout.description'
            defaultMessage='Your serverless project is suspended. This is likely because your free Elastic Cloud Trial has ended. You will be able to resume your project from this page after {billingDetails}.'
            values={{
              billingDetails: (
                <CreditCardModalButton>
                  <FormattedMessage
                    id='project.suspendedCallout.description.billingDetailsLink'
                    defaultMessage='providing your billing details'
                  />
                </CreditCardModalButton>
              ),
            }}
          />
        </p>
      </EuiCallOut>
    )
  }

  return null
}

export default SuspendedProjectCallout
